export default [
    {
        comment: '',
        error_id: 'EM-01',
        data: [
            {cross_section: '43827'},
            {cross_section: '43002'},
        ]
    }
]